function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "path-1-inside-3",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.9658 2.28601C17.9871 0.848087 15.5521 0 12.9189 0C6.29153 0 0.918945 5.37258 0.918945 12C0.918945 18.6274 6.29153 24 12.9189 24C15.5521 24 17.9871 23.1519 19.9658 21.714C18.0453 18.9605 16.9189 15.6118 16.9189 12C16.9189 8.38824 18.0453 5.03955 19.9658 2.28601Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.9658 2.28601C17.9871 0.848087 15.5521 0 12.9189 0C6.29153 0 0.918945 5.37258 0.918945 12C0.918945 18.6274 6.29153 24 12.9189 24C15.5521 24 17.9871 23.1519 19.9658 21.714C18.0453 18.9605 16.9189 15.6118 16.9189 12C16.9189 8.38824 18.0453 5.03955 19.9658 2.28601Z",
  fill: "#5D5D5D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9658 2.28601L20.786 2.85809L21.3471 2.05363L20.5537 1.47705L19.9658 2.28601ZM19.9658 21.714L20.5537 22.523L21.3471 21.9464L20.786 21.1419L19.9658 21.714ZM12.9189 1C15.3339 1 17.5644 1.77704 19.378 3.09497L20.5537 1.47705C18.4099 -0.0808681 15.7703 -1 12.9189 -1V1ZM1.91895 12C1.91895 5.92487 6.84381 1 12.9189 1V-1C5.73924 -1 -0.0810547 4.8203 -0.0810547 12H1.91895ZM12.9189 23C6.84381 23 1.91895 18.0751 1.91895 12H-0.0810547C-0.0810547 19.1797 5.73924 25 12.9189 25V23ZM19.378 20.905C17.5644 22.223 15.3339 23 12.9189 23V25C15.7703 25 18.4099 24.0809 20.5537 22.523L19.378 20.905ZM20.786 21.1419C18.9787 18.5507 17.9189 15.4006 17.9189 12H15.9189C15.9189 15.8229 17.1118 19.3702 19.1456 22.2861L20.786 21.1419ZM17.9189 12C17.9189 8.59937 18.9787 5.44925 20.786 2.85809L19.1456 1.71393C17.1118 4.62984 15.9189 8.17711 15.9189 12H17.9189Z",
  fill: "#5D5D5D",
  mask: "url(#path-1-inside-3)"
});

var SvgRating3 = function SvgRating3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRating3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Rating3.2cbac5cd.svg";
export { ForwardRef as ReactComponent };